// extracted by mini-css-extract-plugin
export var formContainer = "_kh-0";
export var message = "_kh-1";